module.exports = __webpack_public_path__ + "static/img/result_desk_lx.578ea41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_desk_lx.jpg
// module id = yDHb
// module chunks = 3